export const getUserflowToken = (): string | undefined =>
  process.env.REACT_APP_USERFLOW_TOKEN;
export const isUserflowActive = Boolean(getUserflowToken());
